import { useEffect } from "react";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { hasAnyStock } from "../../utils/product/hasAnyStock";
import { StandardProps } from "../componentMap";
import { SwatchUI } from "./SwatchUI";

const SWATCH_ORDER_CHANGED_EVENT =
  "jl-events.browser.swatchOrderProductChanged";

export function Swatch({ product }: Pick<StandardProps, "product">) {
  const { variant } = useVariant(product);

  const isFullyOutOfStock =
    !hasAnyStock(product) &&
    product.__typename === "SimpleProduct" &&
    product.variants?.length === 1;

  const {
    aliases: { pimProductId: productId },
  } = product;
  const {
    aliases: { skuId },
    swatch,
  } = variant;

  const availableToOrder = !!swatch?.availableToOrder;

  useEffect(() => {
    document.body.dispatchEvent(
      new CustomEvent(SWATCH_ORDER_CHANGED_EVENT, {}),
    );
  }, [variant]);

  if (!availableToOrder) {
    return null;
  }

  return (
    <SwatchUI
      isFullyOutOfStock={isFullyOutOfStock}
      skuId={skuId}
      productId={productId}
    />
  );
}
